import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { resources } from './api';
import { Calendar } from '../model/calendar';
import { CalendarException } from '../model/calendar-exception';
import { CalendarExceptionsData, CalendarsData, DataRest, IdDataRest } from '../model/api/data-rest';


@Injectable({
    providedIn: 'root'
})
export class CalendarService {

    constructor(
        private http: HttpClient,
    ) {
    }

    getCalendars(userId?: number, siteId?: number): Observable<CalendarsData> {
        let params = new HttpParams();
        if (userId) {
            params = params.set('userId', userId.toString());
        }
        if (siteId) {
            return this.http.get<CalendarsData>(
                `${environment.apiUrl}${resources.get('calendars')}${resources.get('by')}${resources.get('site')}/${siteId}`,
                { params }
            );
        }
        return this.http.get<CalendarsData>(`${environment.apiUrl}${resources.get('calendars')}`, { params });
    }

    getExceptions(userId?: number): Observable<CalendarExceptionsData> {
        let params = new HttpParams();
        if (userId) {
            params = params.set('userId', userId.toString());
        }
        return this.http.get<CalendarExceptionsData>(`${environment.apiUrl}${resources.get('exceptions')}`, { params });
    }

    addCalendar(calendar: Calendar): Observable<IdDataRest> {
        return this.http.post<IdDataRest>(`${environment.apiUrl}${resources.get('calendars')}`, calendar);
    }

    editCalendar(calendar: Calendar): Observable<DataRest> {
        return this.http.put<DataRest>(`${environment.apiUrl}${resources.get('calendars')}/${calendar.Id}`, calendar);
    }

    deleteCalendar(calendarId: number): Observable<DataRest> {
        return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('calendars')}/${calendarId}`);
    }

    addException(exception: CalendarException): Observable<IdDataRest> {
        return this.http.post<IdDataRest>(`${environment.apiUrl}${resources.get('exceptions')}`, exception);
    }

    deleteException(exceptionId: number): Observable<DataRest> {
        return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('exceptions')}/${exceptionId}`);
    }
}

